module.exports = __webpack_public_path__ + "img/momo_button_back_home.faaca291.png";